<template>
  <div id="footer" :class="$mq !== 'mobile' ? 'container' : ''">
    <div class="link">
      <button @click="showHelp = !showHelp">{{ $t(`footer.help.title`) }}</button>
      <div class="help inline top space-around" v-if="showHelp">
        <div class="col grow">
          <h3>{{ $t(`footer.help.call.title`) }}</h3>
          <h4>{{ $t(`footer.help.call.subtitle`) }}</h4>
          <p>{{ $t(`footer.help.call.text`) }}</p>
        </div>
        <div class="col grow">
          <h3>{{ $t(`footer.help.email.title`) }}</h3>
          <h4>{{ $t(`footer.help.email.subtitle`) }}</h4>
          <p>{{ $t(`footer.help.email.text`) }}</p>
        </div>
        <div class="col grow">
          <h3>{{ $t(`footer.help.mail.title`) }}</h3>
          <h4>{{ $t(`footer.help.mail.subtitle`) }}</h4>
        </div>
      </div>
    </div>
    <div class="trade inline space-between bottom" :class="$mq">
      <div class="info grow">
        © Mega 2019
        <div class="small">{{ $t(`footer.trademark`) }}</div>
      </div>
      <div class="legal">
        <a
          :href="generalCondition"
          target="_blank"
        >{{ $t(`footer.general-condition`) }}</a>
        |
        <a
          :href="condition"
          target="_blank"
        >{{ $t(`footer.condition`) }}</a>
      </div>
    </div>
    <div class="logo margin">
      <img src="@/assets/logoFooterGrey.svg" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showHelp: false
    };
  },
  computed: {
    generalCondition() {
      return this.$i18n.locale === "fr"
        ? "https://www.mega.be/fr/conditions-generales-de-vente"
        : "https://www.mega.be/nl/algemene-voorwaarden";
    },
    condition() {
      return this.$i18n.locale === "fr"
        ? "https://www.mega.be/fr/conditions-d-utilisation"
        : "https://www.mega.be/nl/gebruiksvoorwaarden";
    }
  }
};
</script>

<style lang="scss">
#footer {
  .link {
    margin: 20px 0;
    padding-bottom: 20px;
    border-bottom: 1px solid #eee;
    button {
      color: #fdcb47;
      font-size: 0.9rem;
      font-weight: 600;
      border: 0;
      background: none;

      &:hover {
        color: #231f20;
      }
    }
  }

  .help {
    margin-top: 40px;
    color: #231f20;
    .col {
      min-width: 300px;
      display: flex;
      flex-direction: column;
      align-content: center;
      align-items: center;

      h3 {
        font-size: 1.4rem;
        font-weight: 600;
        margin: 10px 0;
      }
      h4 {
        margin: 0;
      }

      p {
        font-size: 0.9rem;
        color: #231f20;
        width: 70%;
      }
    }
  }

  .info {
    font-size: 0.9rem;
    text-align: left;
    font-weight: 600;
    min-width: 200px;

    .small {
      font-weight: normal;
      font-weight: 500;
      font-size: 0.7rem;
    }
  }

  .trade.mobile {
    margin: 10px;
  }

  .legal {
    list-style: none;
    margin: 0;
    padding: 0;
    flex: 1;
    min-width: 230px;

    a {
      color: #231f20;
      font-weight: normal;
      font-size: 0.7rem;
      color: #231f20;
      text-decoration: none;
      padding: 0 5px;
    }
  }

  .logo {
    text-align: right;
    height: 50px;
    padding-bottom: 30px;
    img {
      height: 100%;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Footer.vue